import { render, staticRenderFns } from "./CourierAddlExpenseList.vue?vue&type=template&id=67354676&"
import script from "./CourierAddlExpenseList.vue?vue&type=script&lang=js&"
export * from "./CourierAddlExpenseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports